import {apiClient} from '../lib/api-client';

interface AuthResult {
    isSuccess: boolean;
    errorMessage: string;
    token: string;
    changePasswordToken: string;
    isPasswordExpired: boolean;
}

interface SignInResult {
    isOk: boolean;
    data?: string;
    message?: string;
    isPasswordExpired?: boolean;
    changePasswordToken?: string;
}

interface ForgotPasswordResult {
    isSuccess: boolean;
    errorMessage: string;
    question: string;
}

interface ChangePasswordResult {
    isSuccess: boolean;
    errorMessage: string;
}

export interface EnvironmentData {
    code: string;
    name: string;
}

export async function signIn(environment: string, userName: string, password: string): Promise<SignInResult> {
    try {
        let data: AuthResult = await apiClient.post("auth", {environment: environment, userName: userName, password: password});
        if (data.isSuccess) {
            return {
                isOk: true,
                data: data.token as string,
                isPasswordExpired: data.isPasswordExpired as boolean,
                changePasswordToken: data.changePasswordToken as string,
            };
        }

        return {
            isOk: false,
            message: data.errorMessage,
        };
    } catch {
        return {
            isOk: false,
            message: "Authentication failed",
        };
    }
}

export async function sendChangeCompany(companyId: number) {
    try {
        let data: AuthResult = await apiClient.post("auth/company", {companyId: companyId});
        if (data.isSuccess) {
            return {
                isOk: true,
                data: data.token as string
            }
        }

        return {
            isOk: false,
            message: data.errorMessage,
        }
    } catch {
        return {
            isOk: false,
            message: "Authentication failed"
        };
    }
}

export async function getUser() {
    try {
        const accessToken = localStorage.getItem('access_token');
        if (accessToken) {
            return {
                isOk: true,
                data: accessToken
            };
        }
    } catch {
    }
    return {
        isOk: false
    };
}

export async function createAccount(email: string, password: string) {
    try {
        // Send request
        console.log(email, password);

        return {
            isOk: true
        };
    } catch {
        return {
            isOk: false,
            message: "Failed to create account"
        };
    }
}

export async function getEnvironments(userName: string) {
    try {
        let data: EnvironmentData[] = await apiClient.post("auth/environments", {userName: userName});
        return data;
    } catch {
        return [];
    }
}

export async function forgotPassword(userName: string, env: string) {
    try {
        let data: ForgotPasswordResult = await apiClient.post("auth/forgot-password", {
            userName: userName,
            environment: env
        });

        return {
            isOk: data.isSuccess,
            question: data.question,
            message: data.errorMessage
        };
    } catch {
        return {
            isOk: false,
            message: "Failed to reset password"
        };
    }
}

export async function changePassword(token: string, password: string) {
    try {
        let data: ChangePasswordResult = await apiClient.post("auth/change-password", {
            token: token,
            password: password
        });

        return {
            isOk: data.isSuccess,
            message: data.errorMessage
        };
    } catch {
        return {
            isOk: false,
            message: "Failed to change password"
        };
    }
}

export async function checkAnswer(userName: string, environment: string, answer: string, token: string) {
    try {
        let data: ForgotPasswordResult = await apiClient.post("auth/check-answer", {
            userName: userName,
            answer: answer,
            environment: environment,
            token: token
        });

        return {
            isOk: data.isSuccess,
            message: data.errorMessage
        };
    } catch {
        return {
            isOk: false,
            message: "Failed to reset password"
        };
    }
}
